import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import { NgxSplideModule } from 'ngx-splide';
import { GOAL_RUSH_HOW_IT_WORKS_SLIDES_RAW } from './goal-rush-how-it-works-slides.data';
import { sliderOptions } from '@app/domain/properties/slider.properties';

export interface GoalRushHowItWorksSlideView {
  readonly title: string;
  readonly img: string;
  readonly html: SafeHtml;
}

@Component({
  selector: 'bingo-how-it-works-goal-rush',
  imports: [NgxSplideModule],
  templateUrl: './how-it-works-goal-rush.component.html',
  styleUrl: './how-it-works-goal-rush.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowItWorksGoalRushComponent {
  private readonly sanitizer = inject(DomSanitizer);
  protected readonly sliderOptions = sliderOptions;

  protected readonly slides: readonly GoalRushHowItWorksSlideView[] = GOAL_RUSH_HOW_IT_WORKS_SLIDES_RAW.map(
    slide => ({
      title: slide.title,
      img: slide.img,
      html: this.sanitizer.bypassSecurityTrustHtml(slide.description),
    }),
  );
}
